import { createContext, useContext } from "react";

export type FieldsScopeContextProps = {
  registerField: (field: string) => void,
  unregisterField: (field: string) => void,
}

export const FieldsScopeContext = createContext<FieldsScopeContextProps>({
  registerField: () => {},
  unregisterField: () => {},
});

export function useFieldsScopeContext(): FieldsScopeContextProps {
  return useContext(FieldsScopeContext);
}
